import { EvaluatorLog } from "@/types/app/log";
import { LogPopover } from "@components/library/Entities/LogPopover";
import { HoverPopover } from "@components/library/Entities/shared/HoverPopover";
import { Align, Side } from "@radix-ui/popper";
import React, { ReactNode, useState } from "react";
import IconButton from "@library/IconButton";
import { CaretDown, CaretUp } from "@phosphor-icons/react";
import { classNames } from "@/lib/utils";

/** Hover card which shows a preview of the outputs of a Log (hard coded to an EvaluatorLog for now) */
export const LogPreview = ({
  evaluatorLog,
  children,
  tooltipContentProps,
  customAction,
  open,
  openDelay,
  closeDelay,
  className,
}: {
  evaluatorLog?: EvaluatorLog;
  tooltipContentProps?: {
    side: Side;
    sideOffset: number;
    align: Align;
  };
  className?: string;
  openDelay?: number;
  closeDelay?: number;
  children: ReactNode;
  open?: boolean;
  customAction?: () => void;
}) => {
  const enabled = open ?? evaluatorLog;
  return (
    <HoverPopover
      openDelay={openDelay ?? 200}
      closeDelay={closeDelay ?? 100}
      trigger={<div className={classNames("", className)}>{children}</div>}
      content={enabled && evaluatorLog && <LogPopover log={evaluatorLog} target="_blank" customAction={customAction} />}
      tooltipContentProps={tooltipContentProps}
    />
  );
};
